import { MobileDeviceUtils } from '../../../shared/scripts/MobileDeviceUtils.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIGameCanvasController } from '../../../shared/scripts/ui_game/UIGameCanvasController.ts';
import { UIMGameResponsiveController } from './UIMGameResponsiveController.ts';
export class UIMGameCanvasController extends UIGameCanvasController {
    // eslint-disable-next-line class-methods-use-this
    get chatWidth() {
        return 0;
    }
    // eslint-disable-next-line class-methods-use-this
    get feedsHeight() {
        return 0;
    }
    get popupWidth() {
        return UIUtilsEjsVariables.isUserOnTabletApp ? this.appW / 2 : this.appW;
    }
    get bottomViewHeight() {
        var _MobileDeviceUtils_getSafeAreaInsetBottom;
        const bottomSafeAreaInset = UIUtilsEjsVariables.isUserOnTabletApp ? 0 : (_MobileDeviceUtils_getSafeAreaInsetBottom = MobileDeviceUtils.getSafeAreaInsetBottom()) !== null && _MobileDeviceUtils_getSafeAreaInsetBottom !== void 0 ? _MobileDeviceUtils_getSafeAreaInsetBottom : 0;
        const bottomViewHeight = this.itemSize * 4 + bottomSafeAreaInset * 0.5;
        const root = document.querySelector(':root');
        root === null || root === void 0 ? void 0 : root.style.setProperty('--bottom-view-height', `${bottomViewHeight}px`);
        return bottomViewHeight;
    }
    setupGameContainers() {
        super.setCanvasConfigVariables();
        this.kickOffAppLoading();
        this.addTicker();
    }
    constructor(uiGameManager){
        super(uiGameManager);
        this.responsiveController = new UIMGameResponsiveController(uiGameManager);
    }
}
